<template>
  <v-card>
    <v-card-title class="justify-center">
      <span class="text-h5">{{ $t('Management of Rehabilitation Plan ') }}</span>
    </v-card-title>
      <v-container
        id="user-profile-view"
        fluid
        tag="section"
      >
        <v-row justify="center">
          <v-col
            cols="12"
            md="12"
          >
            <material-card
              color="primary"
              icon="mdi-application"
            >
              <template #title>
                {{ $t('Project Information') }}
              </template>

              <v-form>
                <v-container class="py-0">

                  <v-row>
                    <v-col
                      cols="12" 
                      md="12"
                    >
                      <v-select 
                        v-if="form_type == 'addForm' || form_type == 'editForm'"
                        color="purple"
                        :items="yearList"
                        :item-value="item=>item.id"
                        :item-text="item=>item.name"
                        :label="$t('Need Submission Year')"
                        v-model="data.year_id"
                        :hint="$t('Mandatory')"
                        :rules="selectRules"
                        persistent-hint
                      >
                         <template v-slot:item="{ item }">
                          <div>{{ getTranslation(item.name) }}</div>
                        </template>
                      </v-select>
                      <div v-if="form_type == 'viewForm'">
                        <p class="font-weight-light">{{ $t('Need Submission Year') }}</p>
                        <p class="text-h4 text--primary">{{ need.year.name }}</p>
                      </div>
                    </v-col>
                  </v-row>

                  <div class="asset-container">

                    <v-row>
                      <!--<v-col
                        cols="12"
                        md="12"
                      >-->
                      <div style="width: 95%;" v-if="form_type == 'addForm' || form_type == 'editForm'">
                          <v-radio-group 
                            v-model="assetTypeSelected"
                            style="display: flex;flex-direction: row;align-items: flex-start;"
                          > 
                            <v-radio :label="$t('Road')" v-bind:value="1"></v-radio>
                            <v-radio :label="$t('Bridge')" v-bind:value="2"></v-radio>
                            <v-radio :label="$t('Irrigation')" v-bind:value="6"></v-radio>
                            <!--<v-radio style="margin-right:20px;" :label="$t('School')" v-bind:value="3"></v-radio>
                            <v-radio style="margin-right:20px;" :label="$t('Hospital')" v-bind:value="4"></v-radio>-->
                            <v-radio :label="$t('Public Building')" v-bind:value="5"></v-radio>
                            <!--<v-radio style="margin-right:20px;" :label="$t('Equipment')" v-bind:value="7"></v-radio>-->
                            <v-radio :label="$t('Other')" v-bind:value="8"></v-radio>
                          </v-radio-group>
                      </div>
                      <div v-if="form_type == 'viewForm'">
                        <p>{{ $t('Asset Type') }}</p>
                        <!--<p class="text-h4 text--primary">{{ getTranslation(need.affected_asset_needs[0].affected_asset.asset_type.translation.name) }}</p>-->
                        <p class="text-h4 text--primary">{{ getTranslation(need.asset_type.translation.name) }}</p>

                      </div>
                      <!--</v-col>-->
                    </v-row>

                    <v-row>
                      <v-col 
                        cols="12" 
                        md="12"
                      >
                        <v-text-field
                          v-if="form_type == 'addForm' || form_type == 'editForm'"
                          v-model="data.name_en"
                          color="purple"
                          type="text"
                          :label="$t('Project Name')"
                          :hint="$t('Mandatory')"
                          :rules="nameRules"
                          persistent-hint
                        />
                        <div v-if="form_type == 'viewForm'">
                          <p>{{ $t('Project Name') }}</p>
                          <p class="text-h4 text--primary">{{ need.name_en }}</p>
                        </div>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col 
                        cols="12" 
                        md="12"
                      >
                        <v-text-field
                          v-if="form_type == 'addForm' || form_type == 'editForm'"
                          v-model="data.description"
                          color="purple"
                          type="text"
                          :label="$t('Description')"
                        />
                        <div v-if="form_type == 'viewForm'">
                          <p>{{ $t('Description') }}</p>
                          <p class="text-h4 text--primary">{{ need.description }}</p>
                        </div>
                      </v-col>
                    </v-row>

                  </div>

                  <div class="location-container">
                    <v-row>
                      <v-col
                        cols="12"
                        md="12"
                      >
                        {{ $t('Project Location') }}
                      </v-col>
                    </v-row>
                    <v-row>  
                      <v-col
                        cols="12"
                        md="12"
                      >
                        <v-select
                          v-if="form_type == 'addForm' || form_type == 'editForm'"
                          v-model="data.province_id"
                          :items="provinceList"
                          :item-value="item=>item.id"
                          :item-text="item=>item.translation.name"
                          :label="$t('Province')"
                          :hint="$t('Mandatory')"
                          :rules="selectRules"
                          persistent-hint
                        >
                          <template v-slot:item="{ item }">
                            <div>{{ getTranslation(item.translation.name) }}</div>
                          </template>
                        </v-select>
                        <div v-if="form_type == 'viewForm'">
                          <p>{{ $t('Province') }}</p>
                          <p class="text-h4 text--primary" v-if="need.province_id !== null">{{ getTranslation(need.province.translation.name) }}</p>
                        </div>
                      </v-col>
                    </v-row>

                    <v-row>  
                      <v-col
                        cols="12"
                        sm="12"
                      >
                        <v-autocomplete
                          v-if="form_type == 'addForm'"
                          :items="districtListSelectedProvince"
                          :item-value="item=>item.id"
                          :item-text="item=>item.translation.name"
                          :label="$t('District')"
                          v-model="data.project_need_districts"
                          :hint="$t('Mandatory')"
                          :rules="selectRules"
                          persistent-hint
                          multiple
                        >
                          <template v-slot:item="{ item }">
                            <div>{{ getTranslation(item.translation.name) }}</div>
                          </template>
                        </v-autocomplete>
                        <v-autocomplete
                          v-if="form_type == 'editForm'"
                          :items="districtListSelectedProvince"
                          :item-value="item=>item.id"
                          :item-text="item=>item.translation.name"
                          :label="$t('District')"
                          v-model="needDistrictInit"
                          :hint="$t('Mandatory')"
                          :rules="selectRules"
                          persistent-hint
                          multiple
                        >
                          <template v-slot:item="{ item }">
                            <div> {{ getTranslation(item.translation.name) }}</div>
                          </template>
                        </v-autocomplete>
                        <div v-if="form_type == 'viewForm' ">
                          <p>{{ $t('District') }}</p>
                          <p v-if="need.project_need_districts.length !== 0" class="text-h4 text--primary" v-for="(dist,district_id) in need.project_need_districts" :key="dist.district_id">{{ getTranslation(dist.district.translation.name) }} ( {{ getTranslation('Province') }}: {{ getTranslation(dist.district.province.translation.name) }} )</p>
                        </div> 
                      </v-col>
                    </v-row>

                  </div>

                  <v-row>
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <v-select 
                        v-if="form_type == 'addForm' || form_type == 'editForm'"
                        color="purple"
                        :items="domainList"
                        :item-value="item=>item.id"
                        :item-text="item=>item.translation.name"
                        :label="$t('Domain')"
                        v-model="data.domain_id"
                        :hint="$t('Mandatory')"
                        :rules="selectRules"
                        persistent-hint
                      >
                       <template v-slot:item="{ item }">
                        <div>{{ getTranslation(item.translation.name) }}</div>
                      </template>
                      </v-select>
                      <div v-if="form_type == 'viewForm'">
                        <p>{{ $t('Domain') }}</p>
                        <p class="text-h4 text--primary">{{ getTranslation(need.domain.translation.name) }}</p>
                      </div>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <v-select 
                        v-if="form_type == 'addForm' || form_type == 'editForm'"
                        color="purple"
                        :label="$t('Type of Investment')"
                        :item-value="item=>item.id"
                        :item-text="item=>item.translation.name"
                        :items="projectTypeList"
                        v-model="data.project_type_id"
                        :hint="$t('Mandatory')"
                        :rules="selectRules"
                        persistent-hint
                      >
                       <template v-slot:item="{ item }">
                          <div>{{ getTranslation(item.translation.name) }}</div>
                        </template>
                      </v-select>
                      <div v-if="form_type == 'viewForm'">
                        <p>{{ $t('Type of Investment') }}</p>
                        <p class="text-h4 text--primary">{{ getTranslation(need.project_type.translation.name) }}</p>
                      </div>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <v-select 
                        v-if="form_type == 'addForm' || form_type == 'editForm'"
                        color="purple"
                        :items="projectSectorList"
                        :item-value="item=>item.id"
                        :item-text="item=>item.translation.name"
                        :label="$t('Sector')"
                        v-model="data.project_sector_id"
                        :hint="$t('Mandatory')"
                        :rules="selectRules"
                        persistent-hint
                      >
                       <template v-slot:item="{ item }">
                        <div>{{ getTranslation(item.translation.name) }}</div>
                      </template>
                      </v-select>
                      <div v-if="form_type == 'viewForm'">
                        <p>{{ $t('Sector') }}</p>
                        <p class="text-h4 text--primary">{{ getTranslation(need.project_sector.translation.name) }}</p>
                      </div>
                    </v-col>
                  </v-row>

                  <v-row>
                    <!--<v-col
                      cols="12"
                      md="12"
                    >
                      <v-select
                        v-if="form_type == 'addForm' || form_type == 'editForm'"
                        v-model="data.disaster_id"
                        :items="disasters"
                        :item-value="item=>item.id"
                        :item-text="item=>item.name_en"
                        :label="$t('Event')"
                      >
                        <template v-slot:item="{ item }">
                          <div>{{ getTranslation(item.name_en) }}</div>
                        </template>
                      </v-select>
                      <div v-if="form_type == 'viewForm'">
                        <p>{{ $t('Event') }}</p>
                        <p v-if="need.disaster !== null" class="text-h4 text--primary">{{ getTranslation(need.disaster.disaster_category.translation.name) }} {{ need.disaster.year.name }}</p>
                        <p v-if="need.disaster === null" class="text-h4 text--primary">/</p>
                      </div>
                    </v-col>-->
                    <v-col
                      cols="6"
                      md="6"
                    >
                      <v-select
                        v-if="form_type == 'addForm' || form_type == 'editForm'"
                        v-model="data.disaster_category_id"
                        :items="disasterCategoryList"
                        :item-value="item=>item.id"
                        :item-text="item=>item.translation.name"
                        :label="$t('Event Type')"
                        :hint="$t('Mandatory')"
                        :rules="selectRules"
                        persistent-hint
                      >
                        <template v-slot:item="{ item }">
                          <div>{{ getTranslation(item.translation.name) }}</div>
                        </template>
                      </v-select>
                      <div v-if="form_type == 'viewForm'">
                        <p>{{ $t('Event Type') }}</p>
                        <p v-if="need.disaster_category !== null" class="text-h4 text--primary">{{ getTranslation(need.disaster_category.translation.name) }}</p>
                        <p v-if="need.disaster_category === null" class="text-h4 text--primary">/</p>
                      </div>
                    </v-col>
                    <v-col
                      cols="6"
                      md="6"
                    >
                      <v-select
                        v-if="form_type == 'addForm' || form_type == 'editForm'"
                        v-model="data.event_year_id"
                        :items="yearList"
                        :item-value="item=>item.id"
                        :item-text="item=>item.name"
                        :label="$t('Event Year')"
                        :hint="$t('Mandatory')"
                        :rules="selectRules"
                        persistent-hint
                      >
                        <template v-slot:item="{ item }">
                          <div>{{ getTranslation(item.name) }}</div>
                        </template>
                      </v-select>
                      <div v-if="form_type == 'viewForm'">
                        <p>{{ $t('Event Year') }}</p>
                        <p v-if="need.event_year !== null" class="text-h4 text--primary">{{ need.event_year.name }}</p>
                        <p v-if="need.event_year === null" class="text-h4 text--primary">/</p>
                      </div>
                    </v-col>
                  </v-row>
                  
                  <v-row>
                    <v-col 
                      cols="12" 
                      md="12"
                    >
                      <v-text-field
                        v-if="form_type == 'addForm' || form_type == 'editForm'"
                        v-model="data.cost"
                        color="purple"
                        type="number"
                        :label="$t('Cost (mLAK)')"
                        :hint="$t('Mandatory')"
                        :rules="numberRules"
                        persistent-hint
                      />
                      <div v-if="form_type == 'viewForm'">
                        <p>{{ $t('Cost (mLAK)') }}</p>
                        <p class="text-h4 text--primary">{{ need.cost.toLocaleString('en-US') }}</p>
                      </div>
                    </v-col>
                  </v-row>  

                  <v-row>
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <v-select
                        v-if="form_type == 'addForm' || form_type == 'editForm'"
                        :items="projectOwnerList"
                        :item-value="item=>item.id"
                        :item-text="item=>item.translation.name"
                        :label="$t('Project Owner')"
                        v-model="data.project_owner_id"
                        :hint="$t('Mandatory')"
                        :rules="selectRules"
                        persistent-hint
                      >
                        <template v-slot:item="{ item }">
                          <div>{{ getTranslation(item.translation.name) }}</div>
                        </template>
                      </v-select>
                      <div v-if="form_type == 'viewForm'">
                        <p class="font-weight-light">{{ $t('Project Owner') }}</p>
                        <p class="text-h4 text--primary">{{ getTranslation(need.project_owner.translation.name) }}</p>
                      </div>
                    </v-col>
                  </v-row>

                  <!-- CONTACT DETAILS --> 
                  <v-row>
                    <v-col 
                      cols="12" 
                      md="12"
                    >
                      <v-text-field
                        v-if="form_type == 'addForm' || form_type == 'editForm'"
                        v-model="data.contact_mail"
                        color="purple"
                        type="text"
                        :label="$t('Project Owner Mail')"
                      />
                      <div v-if="form_type == 'viewForm'">
                        <p class="font-weight-light">{{ $t('Project Owner Mail') }}</p>
                        <p class="text-h4 text--primary">{{ need.contact_mail }}</p>
                      </div>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col 
                      cols="12" 
                      md="12"
                    >
                      <v-text-field
                        v-if="form_type == 'addForm' || form_type == 'editForm'"
                        v-model="data.contact_phone_number"
                        color="purple"
                        type="text"
                        :label="$t('Project Owner Phone Number')"
                      />
                      <div v-if="form_type == 'viewForm'">
                        <p class="font-weight-light">{{ $t('Project Owner Phone Number') }}</p>
                        <p class="text-h4 text--primary">{{ need.contact_phone_number }}</p>
                      </div>
                    </v-col>
                  </v-row>
                  
                  <!-- PICTURE --> 
                  <div>
                    <v-row> <span style="margin: auto;">{{ $t('Photos') }}</span> </v-row> 

                    <v-row style="display: flex;align-items: center;justify-content: center;"> 
                      <v-file-input multiple v-if="form_type == 'addForm' || form_type == 'editForm'" :label="$t('Insert Photos')" v-model="data.project_need_pictures">
                        <!--<template slot="append"> {{ data.project_need_pictures }}</template>-->
                      </v-file-input>
                    </v-row> 

                    <v-row v-if="needPictures.length !== 0">
                      <v-col v-for="(x,index) in needPictures" v-bind:key="index"
                        class="d-flex"
                        cols="12"
                        sm="4"
                      >
                        <v-img style="max-height: 250px; object-fit: contain;" :src="needPictures[index].value" :lazy-src="needPictures[index].value" v-on:click="downloadPlanPicture($store.state.plans.planSelectedPicture[index])" class="hyperlink_document"></v-img>
                        <v-btn v-if="form_type == 'editForm'"
                          style="color:grey;background-color: transparent;"
                          class="delete-button rounded-circle"
                          v-on:click="deletePlanPicture($store.state.plans.planSelectedPicture[index])"
                        > x </v-btn>  
                      </v-col>
                      <v-col v-if="form_type == 'viewForm' && (needPictures.length !== need.project_need_pictures.length) "> {{ $t(' loading ... ') }}</v-col>
                    </v-row> 
                    <v-row v-if="form_type == 'viewForm' && needPictures.length === 0">{{ $t('No Photos') }}</v-row>
                    <v-row v-if="form_type == 'viewForm' && needPictures.length === 0 && (needPictures.length !== need.project_need_pictures.length) ">{{ $t(' loading ... ') }}</v-row>
                  </div>

                  <!-- DOCUMENT --> 
                  <div>
                    <v-row> <span style="margin: auto;">{{ $t('Documents') }}</span> </v-row> 
                    <v-row class="d-flex flex-column" v-if="form_type == 'addForm'">
                      <v-file-input multiple :label="$t('Insert Documents')" v-model="data.project_need_documents"></v-file-input>
                    </v-row>
                    <v-row class="d-flex flex-column" v-if="form_type == 'editForm'">
                      <v-file-input multiple :label="$t('Insert Documents')" v-model="data.project_need_documents_to_insert"></v-file-input>
                    </v-row>
                      
                    <div v-if="form_type == 'viewForm'|| form_type == 'editForm'">
                      <v-row class="hyperlink_document" v-for="(doc, index) in needDocuments" :key="doc.id">
                        <v-col
                          cols="6"
                          md="4"
                        >
                        <span v-on:click="downloadPlanDocument(needDocuments[index], null, null)">{{ needDocuments[index].original_name }}</span> 
                        </v-col>
                        <v-col
                          cols="6"
                          md="4"
                        >
                          <v-btn v-if="form_type == 'editForm'"
                            class="small" color="primary" 
                            v-on:click="deletePlanDocument(needDocuments[index])"> <v-icon>mdi-delete</v-icon> </v-btn>  
                        </v-col>

                      </v-row>
                      <v-row v-if="form_type == 'viewForm' && needDocuments.length === 0">{{ $t('No Documents') }}</v-row>
                    </div>
                  </div>

                </v-container>
              </v-form>
            </material-card>
          </v-col>
        </v-row>
        <v-dialog v-model="dialog_add_asset" persistent max-width="800px" :retain-focus="false">
          <AssetForm 
              v-if="dialog_add_asset" 
              :assetProps="{}" 
              :assetType="parseInt(assetTypeSelected)" 
              :formType="'addForm'" 
              :dialog.sync="dialog_add_asset" 
          />
        </v-dialog>
      </v-container>
    </v-card-text>

    <v-card-actions v-if="form_type == 'addForm'">
      <v-btn 
        class="close-need-button-fixed close-button"
        text
        v-on:click="close_edit()"
      >
        {{ $t('Close') }}
        <v-dialog v-model="dialog_modal_message" persistent max-width="800px" :retain-focus="false">
          <MessageAlert 
              v-if="dialog_modal_message" 
              :messageProps="$store.state.messages.close" 
              :cancelProps="$store.state.messages.no" 
              :validationProps="$store.state.messages.yes" 
              :dialog.sync="dialog_modal_message" 
              @answerModal="getModalAnswer"
          />
        </v-dialog>
      </v-btn>
      <v-btn
        class="save-need-button-fixed"
        color="white darken-1"
        style="background-color:#31c0be;"
        text
        v-on:click="save()"
        v-if="data 
              && data.year_id
              && data.name_en !== ''
              && data.project_owner_id
              && data.project_sector_id
              && data.project_type_id
              && assetTypeSelected !== ''
              && data.province_id
              && data.project_need_districts.length !== 0
              && data.cost > 0"
      > <!--data.affected_asset_id && affectedAssetSelected !== ''-->
        {{ $t('Save') }}
      </v-btn>
    </v-card-actions>

    <v-card-actions v-if="form_type == 'editForm'">
      <v-spacer></v-spacer>
      <v-btn 
        class="close-need-button-fixed close-button"
        text
        v-on:click="close_edit()"
      >
        {{ $t('Close') }}
        <v-dialog v-model="dialog_modal_message" persistent max-width="800px" :retain-focus="false">
          <MessageAlert 
              v-if="dialog_modal_message" 
              :messageProps="$store.state.messages.close" 
              :cancelProps="$store.state.messages.no" 
              :validationProps="$store.state.messages.yes" 
              :dialog.sync="dialog_modal_message" 
              @answerModal="getModalAnswer"
          />
        </v-dialog>
      </v-btn>
      <v-btn
        class="save-need-button-fixed"
        color="white darken-1"
        style="background-color:#31c0be;"
        text
        v-on:click="save()"
        v-if="data 
              && data.year_id
              && data.name_en !== ''
              && data.disaster_category_id
              && data.event_year_id
              && data.project_owner_id
              && data.project_sector_id
              && data.project_type_id
              && assetTypeSelected !== ''
              && data.province_id
              && needDistrictInit.length !== 0
              && data.cost > 0"
      > <!--data.affected_asset_id && affectedAssetSelected !== ''-->
        {{ $t('Save') }}
      </v-btn>
    </v-card-actions>
    <v-card-actions v-if="form_type == 'viewForm'">
      <v-spacer></v-spacer>
      <v-btn
        class="close-need-button-fixed close-button"
        text
        v-on:click="close()"
      >
        {{ $t('Close') }}
      </v-btn>
      <v-btn 
          class="update-need-button-fixed small" 
          color="success" 
          v-on:click="update(need)" 
          v-if="(need.projects.length === 0 || (need.projects.length !== 0 && need.projects[0].deleted_row)) && $store.state.auth.user.user_functions[0].user_type_id !== 1">
        <v-icon>mdi-update</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    name: 'DisasterNeedForm',
    props: {
      need: {
        type: Object
      },
      formType: {
        type: String
      },
     
    },
    data: () => ({
      dialog_add_asset: false,
      dialog_modal_message: false,
      assetTypeSelected: '',
      affectedAssetSelected: '',
      form_type: '',
      data: {},
      districtListSelectedProvince: [],
      needDistrictInit: [],
      needPictures: [],
      pictures_length: 0,
      needDocuments: []
    }),
    computed: {
        yearList() {
          return this.$store.state.referentials.yearList;
        },
        projectOwnerList() {
          return this.$store.state.projects.projectOwnerList;
        }, 
        domainList() {
          return this.$store.state.referentials.domainList;
        },
        projectSectorList() {
          return this.$store.state.referentials.projectSectorList;
        },
        projectTypeList() {
          return this.$store.state.referentials.projectTypeList;
        },
        /*assetTypeList() {
          return this.$store.state.referentials.assetTypeList;
        },
        affectedAssetList() {
          return this.$store.state.assets.affectedAssetList;
        },*/
        provinceList() {
          return this.$store.state.referentials.provinceList;
        },
        districtList() {
          return this.$store.state.referentials.districtList;
        },
        /*villageList() {
          return this.$store.state.referentials.villageList;
        },*/
        /*disasters() {
          return this.$store.state.disasters.disasters;
        },*/
        disasterCategoryList() {
          return this.$store.state.referentials.disasterCategoryList;
        },
        planSelectedPicture() {
          return this.$store.state.plans.planSelectedPicture;
        }, 
        planSelectedDocument() {
          return this.$store.state.plans.planSelectedDocument;
        }, 
    },
    created: function(){
      //https://v15.vuetifyjs.com/en/components/forms/ 
      this.nameRules = [ v => !!v || this.getTranslation('Name is required') ];
      this.numberRules = [ v => v > 0 || this.getTranslation('Positive Number is required') ];
      this.selectRules = [ v => !!v || this.getTranslation('At least 1 Information is required') ];
    },
    mounted: function(){
      this.form_type = this.formType;
      this.$store.dispatch('referentials/getDisasterCategoryList');
      this.$store.dispatch('referentials/getYearList');
      this.$store.dispatch('projects/getProjectOwnerList');
      this.$store.dispatch('referentials/getDomainList');
      this.$store.dispatch('referentials/getProjectSectorList');
      this.$store.dispatch('referentials/getProjectTypeList');
      //this.$store.dispatch('disasters/getDisasters');
      this.$store.dispatch('referentials/getProvinceList');
      this.$store.dispatch('referentials/getDistrictList');

      if(this._props.formType !== 'addForm'){
        //this.$store.dispatch('plans/getPlanSelectedPicture',{project_need_id: this._props.need.id});
        this.$store.dispatch('plans/getPlanSelectedSinglePicture', this._props.need.project_need_pictures);
        this.$store.dispatch('plans/getPlanSelectedDocument',{project_need_id: this._props.need.id});
        this.data.project_need_documents = [];
      }

    },
    watch: { 
      planSelectedPicture: function(value){

        if(this.$store.state.plans.planSelectedPicture.length < this.needPictures.length){

          const imageDeleted = this.needPictures.filter(img1 => !this.$store.state.plans.planSelectedPicture.some(img2 => img2[0].id === img1.id));
          const index = this.needPictures.indexOf(imageDeleted[0]);
          if (index > -1) {
              this.needPictures.splice(index, 1);
          }

        }else if(this.$store.state.plans.planSelectedPicture.length !== this.needPictures.length){

          this.needPictures.push({
            id: value[value.length-1][0].id,
            value: 'data:image/jpeg;base64,' + btoa(value[value.length-1][0].file.data.map(b => String.fromCharCode(b)).join(''))
          });
        }

      },
      planSelectedDocument: function(value){
        this.needDocuments = [];
        for (var i = 0; i < value.length;i ++) {
          this.needDocuments.push(value[i]);
        }
      },
      assetTypeSelected: function(value, oldVal){
        this.data.asset_type_id = value;
      },
      'data.province_id': function(value){
          this.districtListSelectedProvince = this.districtList.filter((dist) => dist.province_id === parseInt(value));
      }
    },
    methods: {
      getHeader(val) {
        return this.$t(val);
      },
      getTranslation(val) {
        return this.$t(val);
      },
      addAssetModal: function(val){
        this.dialog_add_asset = true;
      },
      update: function(val){

        this.data.project_need_documents_to_insert = [];

        //this.assetTypeSelected = val.affected_asset_needs[0].affected_asset.asset_type_id; //V1
        this.assetTypeSelected = val.asset_type_id; //V2
        //this.affectedAssetSelected = val.affected_asset_needs[0].affected_asset_id;
        this.data = val;
        //this.data.affected_asset_id = val.affected_asset_needs[0].affected_asset_id;
        if(this.data.description === null){
          this.data.description = '';
        }

        this.data.initial_province_id = this.data.province_id;
        this.needDistrictInit = [];
        this.data.project_need_districts.forEach(district => this.needDistrictInit.push(district.district_id));

        this.form_type = 'editForm';
      },
      close_edit: function(){
        this.dialog_modal_message = true;
      },
      getModalAnswer(value){
        if(value){
          this.$store.dispatch('plans/getNeeds');
          this.$store.state.plans.planSelectedPicture = [];
          this.$emit('update:dialog', false)
        }
      },
      close: function(){
        this.$store.dispatch('plans/getNeeds');
        this.$store.state.plans.planSelectedPicture = [];
        this.$emit('update:dialog', false)
      },
      save: function(){
        if(this.form_type == 'addForm'){

          if(this.$store.state.auth.user.user_profile_id === 1 || this.$store.state.auth.user.user_profile_id === 2){
            this.data.organization = 'DPI';
          }else{
            this.data.organization = '';
          }

          let project_need_pictures = new FormData();
          project_need_pictures.append("file", this.data.project_need_pictures);

          this.data.new_project_need_documents = [];
          let form = new FormData();
          if(this.data.project_need_documents){
            for(var i=0; i < this.data.project_need_documents.length; i++){
                form.append("file", this.data.project_need_documents[i].name);
                this.data.new_project_need_documents.push({
                  'original_name': this.data.project_need_documents[i].name
                });
            }
          }

          this.$store.dispatch('plans/addNeed',this.data);

          //this.need = this.data;
          //this.form_type = 'viewForm';

        }

        if(this.form_type == 'editForm'){

          this.data.needDistrictInit = this.needDistrictInit;

          this.data.new_project_need_documents = [];

          let project_need_pictures = new FormData();
          project_need_pictures.append("file", this.data.project_need_pictures);

          let form = new FormData();
          if(this.data.project_need_documents_to_insert){
            for(var i=0; i < this.data.project_need_documents_to_insert.length; i++){
              form.append("file", this.data.project_need_documents_to_insert[i].name);
              this.data.new_project_need_documents.push({
                'original_name': this.data.project_need_documents_to_insert[i].name
              });
            }
          }

          this.$store.dispatch('plans/updateNeed',this.data);

          //this.form_type = 'viewForm';
          //this.$emit('update:dialog', false)
        
        }

        this.form_type = 'viewForm';
        this.$emit('update:dialog', false)
      },
      downloadPlanPicture: function(img) {
        this.$store.dispatch('plans/downloadPlanImg', img[0]);
      },
      downloadPlanDocument: function(doc) {
        this.$store.dispatch('plans/downloadPlanDocument', { id:doc.id });
      },
      deletePlanPicture: function(img) {
        this.$store.dispatch('plans/deletePlanImg', img[0]);
        //this.$store.dispatch('plans/deletePlanImg', img);
      },
      deletePlanDocument: function(doc) {
        this.$store.dispatch('plans/deletePlanDocument', doc);
      },
    }
  }
</script>
<style>
  .alarm {
    color: red;
    background-color: white;
    text-align: center;
    margin: auto;
  }
  .close-button {
    background-color: #b6b6b6;
    color: white !important;
  }
 /* .row {
    margin-bottom: 10px !important;
  }*/
  v-btn {
    padding: 2px;
  }
  .v-picker {
    width: 210px;
    height: 300px;
  }
  .v-date-picker-header{
    padding-top: 0px;
    padding-bottom: 0px;
  }
  .v-date-picker-header__value div {
    width: 100%;
  }
  .v-picker__title {
    padding: 7px;
  }
  .v-date-picker-title {
    align-items: center;
  }
  .v-date-picker-table--date th {
    padding: 0px;
  }
  .v-date-picker-table th {
    font-size: 10px;
  }
  .v-picker__body  {
    width: 150px;
    height: 100px;
  }
  div.v-picker__body, div.v-picker-header {
    width: 210px;
  }
  .v-picker__body > div {
      position: relative;
      right: 43px;
      width: 70%;
  }
  .v-picker__title__btn {
    font-size: 10px;
  }
  .v-date-picker-header__value {
    font-size: 10px;
    width: 150px;
  }
  .v-date-picker-table {
    width: 210px;
    padding: 0px;
    height: 100px;
  }
  .v-btn--icon.v-size--default {
    height: 30px;
    width: 30px;
}
.v-btn--icon.v-size--default .v-icon {
    height: 15px;
    font-size: 15px;
    width: 15px;
}
.v-date-picker-table--date .v-btn {
    height: 20px;
    width: 20px;
}
.v-date-picker-table .v-btn {
  font-size: 10px;
}
.asset-container {
  border: 1px solid grey;
}
.location-container {
  border: 1px solid grey;
  margin-top: 5px;
}
.v-input--radio-group--column .v-input--radio-group__input {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}
.v-application--is-ltr .v-input--selection-controls__input {
    margin-left: 10px;
}
.close-need-button-fixed {
    position: fixed;
    right: 650px;
    bottom: 53px;
}
.save-need-button-fixed {
    position: fixed;
    right: 570px;
    bottom: 53px;
}
.update-need-button-fixed {
    position: fixed;
    right: 570px;
    bottom: 53px;
}

</style>
